<template>
    <a-form
        :model="formState"
        name="basic"
        :label-col="{ span: 0 }"
        :wrapper-col="{ span: 24 }"
        autocomplete="off"
        @finish="onFinish"
        @finishFailed="onFinishFailed"
    >
        <a-form-item
            name="username"
            :rules="[{ required: true, message: 'Por favor introduzca un usuario' }]"
            :wrapper-col="{ offset: 0, span: 12 }"
        >
            <a-input ref="usernameInput" v-model:value="formState.username" placeholder="Usuario" @blur="convertToLowerCase" />
        </a-form-item>
        <a-form-item
            name="password"
            :rules="[{ required: true, message: 'Por favor introduzca una contraseña' }]"
            :wrapper-col="{ offset: 0, span: 12 }"
        >
            <a-input-password v-model:value="formState.password" placeholder="Contraseña" />
        </a-form-item>
        <a-flex justify="space-around" gap="middle">
            <router-link to="recovery_password" style="font-size: 14px;">Recuperar contraseña</router-link>
            <a-checkbox v-model:checked="formState.remember">Recordar usuario</a-checkbox>
        </a-flex>
        <a-form-item :wrapper-col="{ offset: 0, span: 12 }">
            <a-button type="primary" html-type="submit" size="large" style="width: 100%">Entrar</a-button>
            <a-button v-if="typeLogin != 'default'" type="secondary" size="large" style="width: 100%" @click="registerContact(typeLogin)">Registrarse</a-button>
        </a-form-item>
    </a-form>
</template>
<script setup>
import { ref, reactive, nextTick } from 'vue';
import { sleep, manageLogin, login_cliente, openNotificationWithIcon } from '@/plugins/odoo'
import { useRouter } from 'vue-router';
import { stringType } from 'ant-design-vue/es/_util/type';
const emit = defineEmits(['handleLoading'])
const props = defineProps({
    typeLogin: {
        type: String,
        default: 'default'
    }
})
const router = useRouter(); 
const formState = reactive({
    username: '',
    password: '',
    remember: true,
    showAlert: false,
    MessageAlert: '',
});
const usernameInput = ref(null);
const focusUsernameInput = () => {
  nextTick(() => {
    usernameInput.value.focus();
  });
}
const onFinish = async (values) => {
    emit('handleLoading', true, 'Verificando Usuario');
    // console.log(formState)
    values.username = values.username.toLowerCase();    
    const response = await login_cliente(values);
    // console.log(response)
    if (response.data.arguments) {
        if (response.data.arguments[0] === "Access Denied") {
            emit('handleLoading', true, 'Acceso Denegado');
            formState.MessageAlert = "Error de inicio de sesión! Credenciales inválidas.";
            // formState.username = '';
            formState.password = '';
            openNotificationWithIcon(formState.MessageAlert, "Por favor, revisa su informacion de usuario y vuelva a intentar", "warning");
            focusUsernameInput()
        } else if (response.data.arguments[0] === "new") {
            emit('handleLoading', true, 'Cliente Nuevo');
            await sleep(1000)
            manageLogin(router, values.username, response.data.arguments[0], response.data.arguments[1])
        } else if (response.data.arguments[0] === "Token Invalid") {
            router.replace("/401")
        } else {
            console.log(response.data.arguments)
        }
    } else if (response.data) {
        // console.log(response.data)
        emit('handleLoading', true, 'Iniciando Dashboard de usuario');
        manageLogin(router, response),
        emit('handleLoading', true, 'Cargando imágenes');
    } else {
       console.log(response) 
       openNotificationWithIcon("ERROR DE COMUNICACION", "Se presento un problema con nuestro sistema, comuniquese a nuestra sede para mas información", "warning");
    }
    emit('handleLoading', false);
};
const onFinishFailed = errorInfo => {
    // console.log('Failed:', errorInfo);
    console.log('Fail');
    emit('handleLoading', false);
    formState.showAlert = true;
    formState.username = '';
    formState.password = '';
    formState.MessageAlert = errorInfo;
    setTimeout(() => {
        formState.showAlert = false;    
    }, 3000);

};
const convertToLowerCase = () => {
  formState.username = formState.username.toLowerCase();
};
const registerContact = (typeLogin) => {
    switch(typeLogin) {
        case "aliado_comercial":
            router.push('/registro_aliado');
            break;
        default:
            router.push('/401');
            break;
    }
}
</script>